import { DataModel, ReferenceModel } from "../../base/index.js";
import { provideReact } from "../../react/index.js";
import { config } from "../../config/config.js";
import { classes } from "polytype";
import { User } from "../../user/index.js";
import type { NewsletterInfoData } from "./types.js";

export class Newsletter extends ReferenceModel {
  public static getInfo = provideReact(async () => {
    const data = await config.behaviors.newsletter.getInfo();

    return new NewsletterInfo(data);
  });

  public static async subscribe() {
    const user = await User.ofId("self").getDetailed();

    await config.behaviors.newsletter.subscribe({
      firstName: user.firstName,
      lastName: user.lastName,
    });
  }

  public static async unsubscribe() {
    await config.behaviors.newsletter.unsubscribe();
  }
}

export class NewsletterInfo extends classes(
  DataModel<NewsletterInfoData>,
  Newsletter,
) {
  public readonly status: "active" | "inactive" | "confirmationPending";
  public constructor(data: NewsletterInfoData) {
    super([data], [data.email]);
    this.status = data.active
      ? "active"
      : data.registered
        ? "confirmationPending"
        : "inactive";
  }
}
